import { render, staticRenderFns } from "./dfdcTable.vue?vue&type=template&id=05e0cf5c&scoped=true"
import script from "./dfdcTable.vue?vue&type=script&lang=ts"
export * from "./dfdcTable.vue?vue&type=script&lang=ts"
import style0 from "./dfdcTable.vue?vue&type=style&index=0&id=05e0cf5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0cf5c",
  null
  
)

export default component.exports